import * as React from "react";
import PropTypes from "prop-types";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import Typography from "@mui/material/Typography";
import { maxWidth } from "@mui/system";
import { Grid } from "@mui/material";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    // padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    // padding: theme.spacing(1),
  },
}));

const BootstrapDialogTitle = (props) => {
  const { children, onClose, ...other } = props;

  return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
      {children}
      {onClose ? (
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "#EA1D1F",
          }}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </DialogTitle>
  );
};

BootstrapDialogTitle.propTypes = {
  children: PropTypes.node,
  onClose: PropTypes.func.isRequired,
};

export default function TableDailog({ open, handleClose, table }) {
  let [guestNo, setGuestNo] = React.useState(0);

  const incrementHandle = () => {
    setGuestNo(guestNo + 1);
  };
  const decrementHandle = () => {
    guestNo > 0 && setGuestNo(guestNo - 1);
  };
  return (
    <div>
      <BootstrapDialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        style={{}}
        sx={{
          margin: "auto",
        }}
      >
        <div
          style={{
            minWidth: "335px",
            // minHeight: "295px",
            borderRadius: 4,
          }}
        >
          <BootstrapDialogTitle
            id="customized-dialog-title"
            onClose={handleClose}
            style={{
              fontWeight: "500",
              fontFamily: `Poppins, sans-serif`,
              fontSize: 16,
            }}
          >
            Create a new table
          </BootstrapDialogTitle>
          <div
            style={{
              margin: 15,
            }}
          >
            <Grid container>
              <Grid item xs={4}>
                <div
                  style={{
                    fontWeight: "500",
                    fontFamily: `Poppins, sans-serif`,
                    fontSize: 16,
                  }}
                >
                  Table
                </div>
                <div style={{ color: "#464545", fontSize: 15 }}>{table}</div>
              </Grid>
              <Grid item xs={4}>
                <div
                  style={{
                    fontWeight: "500",
                    fontFamily: `Poppins, sans-serif`,
                    fontSize: 16,
                  }}
                >
                  Time
                </div>
                <div style={{ color: "#464545", fontSize: 15 }}>05:30 PM</div>
              </Grid>
              <Grid item xs={4}>
                <div
                  style={{
                    fontWeight: "500",
                    fontFamily: `Poppins, sans-serif`,
                    fontSize: 16,
                  }}
                >
                  Waiter
                </div>
                <div style={{ color: "#464545", fontSize: 15 }}>Kawser</div>
              </Grid>
            </Grid>
          </div>

          <div
            style={{
              margin: 15,
            }}
          >
            <div
              style={{
                color: "#000",
                fontWeight: "500",
                fontFamily: `Poppins, sans-serif`,
                fontSize: 16,
              }}
            >
              Guests
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginTop: 15,
                  marginBottom: 25,
                }}
              >
                <div
                  style={{
                    background: "#EA1D1F",
                    borderRadius: 4,
                    width: 37,
                    height: 28,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#FFF",
                    cursor: "pointer",
                  }}
                  onClick={decrementHandle}
                >
                  -
                </div>
                <div
                  style={{
                    width: 37,
                    height: 28,
                    color: "#000",
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                  }}
                >
                  {guestNo}
                </div>
                <div
                  style={{
                    background: "#EA1D1F",
                    borderRadius: 4,
                    width: 37,
                    height: 28,
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    color: "#FFF",
                    cursor: "pointer",
                  }}
                  onClick={incrementHandle}
                >
                  +
                </div>
              </div>
            </div>
          </div>

          <Button
            onClick={handleClose}
            style={{
              background: "#0E5A41",
              color: "#FFF",
              width: 335,
              height: 48,
              borderRadius: 4,
            }}
          >
            Done
          </Button>
        </div>
      </BootstrapDialog>
    </div>
  );
}
